var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "w-card",
        { style: { height: "100%" } },
        [
          _c(
            "w-card-title",
            [
              _c("span", [_vm._v(_vm._s(_vm.title))]),
              _c("w-spacer"),
              _vm.$wf.isMdDown
                ? [
                    _c(
                      "w-link",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.back"),
                            expression: "$ct('common.back')",
                          },
                        ],
                        staticClass: "mr",
                        attrs: { white: "" },
                        on: {
                          click: function ($event) {
                            return _vm.back()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                      1
                    ),
                    _c(
                      "w-link",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.edit"),
                            expression: "$ct('common.edit')",
                          },
                        ],
                        staticClass: "mr",
                        attrs: { white: "" },
                        on: {
                          click: function ($event) {
                            return _vm.edit()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                    _c(
                      "w-dropdown",
                      {
                        attrs: {
                          items: _vm.toolbarActions,
                          right: "",
                          flat: "",
                          "use-link": "",
                          white: "",
                        },
                        on: {
                          click: function ($event) {
                            return $event()
                          },
                        },
                      },
                      [
                        _c("w-fa", {
                          staticClass: "mr",
                          attrs: { icon: "ellipsis-v" },
                        }),
                      ],
                      1
                    ),
                  ]
                : _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.close"),
                          expression: "$ct('common.close')",
                        },
                      ],
                      staticClass: "mr",
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.back()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
            ],
            2
          ),
          _c(
            "w-card-content",
            { staticClass: "content" },
            [
              _c(
                "w-container",
                { style: { flexGrow: 1 } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c(
                            "w-row",
                            { attrs: { "no-margin": "" } },
                            [
                              _c("w-tabs", {
                                staticClass: "light",
                                attrs: { tabs: _vm.tabs },
                                model: {
                                  value: _vm.activeTab,
                                  callback: function ($$v) {
                                    _vm.activeTab = $$v
                                  },
                                  expression: "activeTab",
                                },
                              }),
                              _c("w-spacer"),
                              _vm.$wf.isLgUp
                                ? _c(
                                    "w-button-bar",
                                    [
                                      _c(
                                        "w-button",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.$ct("common.back"),
                                              expression: "$ct('common.back')",
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.back()
                                            },
                                          },
                                        },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "arrow-left" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "w-button",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: _vm.$ct("common.edit"),
                                              expression: "$ct('common.edit')",
                                            },
                                          ],
                                          attrs: { disabled: !_vm.canEdit },
                                          on: {
                                            click: function ($event) {
                                              return _vm.edit()
                                            },
                                          },
                                        },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "pen" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._l(
                                        _vm.toolbarActions,
                                        function (action, i) {
                                          return [
                                            _c(
                                              "w-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value: action.text,
                                                    expression: "action.text",
                                                  },
                                                ],
                                                key: i,
                                                style: {
                                                  borderRightStyle:
                                                    action.value == _vm.print ||
                                                    action.value ==
                                                      _vm.openSendModal
                                                      ? "none"
                                                      : undefined,
                                                },
                                                attrs: {
                                                  "thin-right":
                                                    action.value == _vm.print ||
                                                    action.value ==
                                                      _vm.openSendModal,
                                                  disabled: action.disabled,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return action.value()
                                                  },
                                                },
                                              },
                                              [
                                                _c("w-fa", {
                                                  attrs: { icon: action.icon },
                                                }),
                                              ],
                                              1
                                            ),
                                            action.value == _vm.print
                                              ? _c(
                                                  "w-dropdown",
                                                  {
                                                    key: `${i}-dropdown`,
                                                    attrs: {
                                                      items:
                                                        _vm.extraPrintActions,
                                                      thin: "",
                                                      right: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return $event()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("w-fa", {
                                                      attrs: {
                                                        icon: "chevron-down",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            action.value == _vm.openSendModal
                                              ? _c(
                                                  "w-dropdown",
                                                  {
                                                    key: `${i}-dropdown`,
                                                    attrs: {
                                                      items:
                                                        _vm.extraSendActions,
                                                      thin: "",
                                                      right: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return $event()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("w-fa", {
                                                      attrs: {
                                                        icon: "chevron-down",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.canBeSignedByClient &&
                              _vm.$wf.isMdUp &&
                              !_vm.sale.IsSigned
                                ? _c(
                                    "w-button",
                                    {
                                      staticClass: "ml",
                                      on: {
                                        click: function ($event) {
                                          _vm.signModalOpen = true
                                        },
                                      },
                                    },
                                    [
                                      _c("w-fa", {
                                        staticClass: "mrs",
                                        attrs: { icon: "signature" },
                                      }),
                                      _vm._v(
                                        " " + _vm._s(_vm.$ct("sign")) + " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    { style: { flexGrow: 1, flexShrink: 1 } },
                    [
                      _c(
                        "w-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeTab < 2,
                              expression: "activeTab<2",
                            },
                          ],
                          style: { flexGrow: 1, flexShrink: 1 },
                          attrs: { lg: "9", xs: "12" },
                        },
                        [
                          _vm.activeTab == 0 && _vm.sale
                            ? _c("app-sale-info-overview", {
                                attrs: { sale: _vm.sale },
                              })
                            : _vm._e(),
                          _vm.loaded
                            ? _c("app-sale-pdf-preview", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeTab == 1,
                                    expression: "activeTab==1",
                                  },
                                ],
                                key: _vm.pdfKey,
                                attrs: {
                                  layout: _vm.layout,
                                  load: _vm.activeTab == 1,
                                  sale: _vm.sale,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.$wf.isXl && _vm.activeTab < 2
                        ? _c(
                            "w-col",
                            {
                              style: { flexGrow: 1, flexShrink: 1 },
                              attrs: { lg: "3", xs: "12" },
                            },
                            [
                              _c("app-sale-history", {
                                attrs: { sale: _vm.sale },
                              }),
                              _c("app-sale-references", {
                                attrs: {
                                  "import-referenced-sales":
                                    _vm.importReferencedSales,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm.$wf.isMdUp && _vm.activeTab == 2
                        ? _c(
                            "w-col",
                            {
                              style: { flexGrow: 1, flexShrink: 1 },
                              attrs: { xs: "12" },
                            },
                            [
                              _c("app-sale-info-aws-documents", {
                                attrs: { sale: _vm.sale },
                                on: {
                                  upload: function ($event) {
                                    return _vm.uploadAwsDocuments()
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : !_vm.$wf.isMdUp && _vm.activeTab == 2
                        ? [
                            _c(
                              "w-col",
                              { attrs: { xs: "12" } },
                              [
                                _c("app-sale-info-aws-documents", {
                                  attrs: { sale: _vm.sale },
                                  on: {
                                    upload: function ($event) {
                                      return _vm.uploadAwsDocuments()
                                    },
                                  },
                                }),
                                _c("app-sale-references", {
                                  attrs: {
                                    "import-referenced-sales":
                                      _vm.importReferencedSales,
                                  },
                                }),
                                _c("app-sale-history", {
                                  attrs: { sale: _vm.sale },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm.activeTab >= _vm.customViewTabStartIndex &&
                      _vm.customViewTabs.length > 0
                        ? _c(
                            "w-col",
                            {
                              style: { flexGrow: 1, flexShrink: 1 },
                              attrs: { xs: "12" },
                            },
                            [
                              _c("app-custom-view-tab-frames", {
                                attrs: {
                                  model: _vm.sale,
                                  tab: _vm.activeTab,
                                  "start-tab-index":
                                    _vm.customViewTabStartIndex,
                                  tabs: _vm.customViewTabs,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.sendModal
                ? _c("app-send-modal", {
                    attrs: {
                      sale: _vm.sale,
                      "extra-print-options": _vm.sendWithExtraPrintOptions,
                    },
                    on: {
                      close: function ($event) {
                        _vm.sendModal = false
                      },
                      sent: function ($event) {
                        return _vm.mailSent()
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.publicLinkModal,
                    callback: function ($$v) {
                      _vm.publicLinkModal = $$v
                    },
                    expression: "publicLinkModal",
                  },
                },
                [
                  _c("app-public-link", {
                    attrs: { link: _vm.publicLink },
                    on: {
                      cancel: function ($event) {
                        _vm.publicLinkModal = false
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.signModalOpen,
                    callback: function ($$v) {
                      _vm.signModalOpen = $$v
                    },
                    expression: "signModalOpen",
                  },
                },
                [
                  _vm.signModalOpen
                    ? _c("app-sign-sale-modal", {
                        attrs: { sale: _vm.sale },
                        on: {
                          close: function ($event) {
                            _vm.signModalOpen = false
                          },
                          signed: function ($event) {
                            ;(_vm.signModalOpen = false), _vm.onSign($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-modal",
                { attrs: { value: _vm.printWithExtraOptionsModalOpen } },
                [
                  _vm.printWithExtraOptionsModalOpen
                    ? _c("app-sale-print-extra-options-modal", {
                        attrs: { sale: _vm.sale },
                        on: {
                          close: function ($event) {
                            _vm.printWithExtraOptionsModalOpen = false
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-modal",
                { attrs: { value: _vm.peppolModalOpen } },
                [
                  _vm.peppolModalOpen
                    ? _c("app-send-via-peppol-modal", {
                        attrs: { sale: _vm.sale },
                        on: {
                          close: function ($event) {
                            _vm.peppolModalOpen = false
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }